import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";

export function setModoTela(modo) {
  return {
    type: "MENSALIDADE_MODO_TELA",
    payload: {
      modo: modo,
    },
  };
}

export function setFiltro(filtro) {
  return {
    type: "MENSALIDADE_SET_FILTRO",
    payload: filtro,
  };
}

export function setAguardando(aguardando) {
  return {
    type: "MENSALIDADE_SET_AGUARDANDO",
    payload: aguardando,
  };
}

export function setResultadoEnvio(resultado) {
  return {
    type: "MENSALIDADE_SET_RESULTADO_ENVIO",
    payload: resultado,
  };
}

export function setTodasEnviadasSemErro(todasSemErro) {
  return {
    type: "MENSALIDADE_SET_TODAS_ENVIADAS_SEM_ERRO",
    payload: todasSemErro,
  };
}

export function getMensalidades() {
  return async (dispatch, getState) => {
    const filtro = getState().mensalidade.filtro;

    if (!filtro.id_sindicato_acesso || !filtro.data) {
      setError("Preencha os campos para buscar as mensalidades");
      return {};
    }

    const dataFormatada = formatarData(filtro.data);
    try {
      dispatch(setResultadoEnvio(null));
      dispatch(setAguardando(true));

      const request = await axios.get(
        `${consts.API_URL}/integracao/mensalidades?id_sindicato_acesso=${filtro.id_sindicato_acesso}&data=${dataFormatada}`
      );
      dispatch({
        type: "MENSALIDADE_LISTADO",
        payload: request,
      });
    } catch (erro) {
      setError("Erro ao buscar mensalidades do sindicato");
    } finally {
      dispatch(setAguardando(false));
    }
  };
}

export function reprocessarMensalidades() {
  return async (dispatch, getState) => {
    const filtro = getState().mensalidade.filtro;

    if (!filtro.id_sindicato_acesso || !filtro.data) {
      setError("Preencha os campos para buscar as mensalidades");
      return {};
    }

    const dataFormatada = formatarData(filtro.data);
    dispatch(setAguardando(true));
    try {
      const request = await axios.get(
        `${consts.API_URL}/integracao/reprocessar/mensalidades?id_sindicato_acesso=${filtro.id_sindicato_acesso}&data=${dataFormatada}`
      );
      dispatch({
        type: "MENSALIDADE_LISTADO",
        payload: { data: [] },
      });

      const listaRetornada = (request.data || [])
        .filter((item) => !item.status || item.tipo_erro) // pega apenas os com erro
        .reduce((acc, atual) => {
          const objeto_enviado = JSON.parse(atual.objeto_enviado);
          const nReciboAtual = objeto_enviado.nRecibo;

          const existe = acc.find((item) => item.nRecibo === nReciboAtual);

          if (!existe) {
            acc.push({
              tipo_erro: atual.tipo_erro,
              descricao_erro: atual.descricao_erro,
              ano: objeto_enviado.ano,
              mes: objeto_enviado.mes,
              data: objeto_enviado.data,
              nRecibo: objeto_enviado.nRecibo,
              valorMes: objeto_enviado.valorMes,
              total: objeto_enviado.total,
            }); // 👈 adiciona o registro real
          }

          return acc;
        }, []);

      dispatch({
        type: "MENSALIDADE_RETORNO_LISTADO",
        payload: { data: listaRetornada },
      });

      if (listaRetornada.length) {
        setError("O envio de alguns registros falhou, verifique na tabela");
        dispatch(
          setResultadoEnvio(
            "O envio de alguns registros falhou, verifique na tabela abaixo."
          )
        );
      } else {
        setSuccess("Todos os registros foram enviados com sucesso.");
        dispatch(
          setResultadoEnvio("Todos os registros foram enviados com sucesso.")
        );
      }
    } catch (erro) {
      setError(
        "Não foi possível enviar para a FETAG, entre em contrato com o suporte"
      );
    } finally {
      dispatch(setAguardando(false));
    }
  };
}

function formatarData(data) {
  if (!data) throw new Error("Data Inválida");
  return `${data.getFullYear()}-${data.getMonth() < 9 ? "0" : ""}${
    data.getMonth() + 1
  }-${data.getDate() < 10 ? "0" : ""}${data.getDate()}`;
}
